// 261023 E3-P3h2/3 (H3 / H10, smoke 26/10) — ĐÚNG MỘT nút đỏ mỗi màn workbench. Nút `primary` / `danger` chỉ được đỏ khi nó là CTA chính của chỗ dừng (`cta`); mọi nút khác hạ về trung tính.
// THUẦN, không antd/react: `WbButton.tsx` chỉ áp kết quả. «Chủ nút đỏ» (`ctaOwnerOf`) quyết định ai giữ CTA.

export type BtnType = 'default' | 'primary' | 'dashed' | 'link' | 'text' | undefined;
export interface BtnLook { type?: BtnType; danger?: boolean; ghost?: boolean }

/** Nút không phải CTA: `primary` → `default`, bỏ `danger` (kể cả link/text đỏ), bỏ `ghost`. CTA giữ nguyên. */
export const demoteBtn = (look: BtnLook, cta: boolean): BtnLook => {
  if (cta) return look;
  const needs = look.type === 'primary' || !!look.danger || !!look.ghost;
  if (!needs) return look;
  return { ...look, type: look.type === 'primary' ? 'default' : look.type, danger: false, ghost: false };
};

export type CtaOwner = 'sticky' | 'pushbar' | 'band' | 'stage';
export interface CtaCtx {
  /** Dải chuỗi (hoặc dải «Phần mới») đang có nút chính BẤM ĐƯỢC. */
  bandHoldsCta: boolean;
  /** Đang ở Sổ duyệt và đã tick ≥ 1 tập. */
  reviewTicked: boolean;
}

/**
 * Ai giữ nút đỏ duy nhất: thanh dính của Sổ khi đã tick (K11) ▸ dải chuỗi khi có nút chính bấm được ▸ còn lại là CTA của chính bước (truyện không có dải).
 * Thanh dính ⑤ (`pushbar`) là CTA của bước ⑤ — chỉ khi dải KHÔNG giữ.
 */
export const ctaOwnerOf = (c: CtaCtx): CtaOwner => (c.reviewTicked ? 'sticky' : c.bandHoldsCta ? 'band' : 'stage');

/** `who` có được đỏ không, theo chủ đã quyết. `stage`/`pushbar` đều là «CTA của bước» nên cùng điều kiện. */
export const holdsCta = (owner: CtaOwner, who: 'sticky' | 'pushbar' | 'band' | 'stage'): boolean => (who === 'pushbar' || who === 'stage' ? owner === 'stage' : owner === who);

/** Nút «Đẩy sang Chapters…» ở header Sổ: ẩn khi dải chuỗi đang giữ việc đẩy; còn lại hiện (trung tính) cho truyện không có dải. */
export const showReviewHeaderPush = (bandHoldsPush: boolean): boolean => !bandHoldsPush;

/** Mức tối thiểu của khuôn bước (px) để còn dùng được; thấp hơn thì chấp nhận trang ngoài cuộn. */
export const MIN_FRAME_HEIGHT = 320;
/**
 * R4/F7 — chiều cao khung = cao cửa sổ − đỉnh lưới theo TOẠ ĐỘ TÀI LIỆU (đã cộng mọi vị trí cuộn của tổ tiên) − 24. 3k-c lượt 2: khuôn VỪA KHÍT màn để trang ngoài không cuộn
 * (cột trái cuộn riêng danh sách tập, vùng nội dung cuộn riêng); chỉ chặn dưới ở `MIN_FRAME_HEIGHT` (trước là 560 — kéo khuôn tràn khỏi màn thấp). Số hỏng ⇒ mức tối thiểu.
 */
export const frameHeightOf = (innerHeight: number, docTop: number): number =>
  (Number.isFinite(innerHeight) && Number.isFinite(docTop) ? Math.max(MIN_FRAME_HEIGHT, Math.round(innerHeight - docTop - 24)) : MIN_FRAME_HEIGHT);
